import { BeaconWallet } from '@taquito/beacon-wallet';
import { TezosToolkit } from '@taquito/taquito';
import { NetworkType } from '@airgap/beacon-sdk';
import NETWORKS from './networkconfig.js';

class WalletManager {
  constructor(network) {
    this.network = network;
    this.rpc = NETWORKS[this.network].rpc;
    this.contract = NETWORKS[this.network].contract;
    this.tezos = new TezosToolkit(this.rpc);

    // Provide network when instantiating the wallet (via DAppClient)
    this.wallet = new BeaconWallet({
      name: 'ZeroZar',
      preferredNetwork: this.network === 'mainnet' ? NetworkType.MAINNET : NetworkType.GHOSTNET,
    });

    this.tezos.setWalletProvider(this.wallet);
    this.address = null;
    this.chainId = null;
  }

  async connect() {
    // Remove network param here, just request permissions directly
    await this.wallet.requestPermissions();

    this.address = await this.wallet.getPKH();
    this.chainId = await this.tezos.rpc.getChainId();
    return this.address;
  }

async disconnect() {
  if (this.wallet && this.wallet.client) {
    await this.wallet.client.disconnect();
  }
  this.address = null;
  this.chainId = null;
}


  getAddress() {
    return this.address;
  }

  getNetwork() {
    return this.network;
  }
}

export default WalletManager;
